export function dateStringFormat(fullString: string) {
  const dateString = fullString.match(/\d{4}([.\-/ ])\d{2}\1\d{2}/) || [
    '0000-00-00',
  ];
  const formatedDateString = new Date(dateString[0])
    .toLocaleString('pt-BR', { timeZone: 'UTC' })
    .split(',')[0];

  const formatedFullString = fullString.replace(
    /\d{4}([.\-/ ])\d{2}\1\d{2}/,
    formatedDateString,
  );
  return formatedFullString;
}
